<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="erro" v-if="mensagemErro">
      <h4>{{mensagemErro}}</h4>
    </div>
    <div v-if="mostraDocumento">
      <meu-painel>
        <h3 class="centralizado">AUTORIZAÇÃO PARA CONSULTA AO SISTEMA DE INFORMAÇÃO DE CRÉDITO (SCR)</h3>
        <br />
        <br />
        <p>
          Eu, {{dadosCliente.name}}, inscrito no {{dadosCliente.document}} {{dadosCliente.document === 'CPF' ? formatCpf(dadosCliente.tax_id) : formatCnpj(dadosCliente.tax_id)}}, em virtude de operação de crédito,
          de qualquer natureza, pleiteada através do marketplace de crédito da Nagro, autorizo
          à Nagro Crédito Agro Ltda., inscrita no CNPJ sob o nº 22.165.622/0001-02, a consultar, a
          qualquer tempo, os débitos e responsabilidades decorrentes de operações com características de
          crédito que em meu nome e de minhas empresas, constem ou venham a constar do Sistema de Informações
          de Crédito(SCR), gerido pelo Banco Central do Brasil - Bacen, ou dos sistemas que venham a
          complementá-lo ou a substituí-lo.
          <br />
          <br />Autorizo também à Nagro Crédito Agro Ltda. a compartilhar os dados desta consulta com qualquer uma
          das fontes financeiras(instituições financeiras ou não), nas quais possa pleitear operação de
          crédito, de qualquer natureza, por intermediação da Nagro.
        </p>
        <br />
        <p>Declaro ainda, ser de meu conhecimento que:</p>
        <p>1. As consultas ao SCR serão realizadas com base na presente autorização.</p>
        <p>
          2. O SCR tem por finalidades prover informações ao Banco Central do Brasil,
          para fins de monitoramento do crédito no sistema financeiro e para o exercício
          de suas atividades de fiscalização e propiciar o intercâmbio de informações entre
          instituições financeiras, conforme definido no § 1º do art. 1º da Lei Complementar nº 105,
          de 10 de janeiro de 2001, sobre o montante de responsabilidades de produceres em
          operações de crédito;
        </p>
        <p>
          3. Poderei ter acesso aos dados constantes em meu nome no SCR por meio do
          sistema “registrato” do Banco Central do Brasil - Bacen;
        </p>
        <br />
        <br />
        <p class="centralizado">Uberlândia, {{date.dia}} de {{date.mes}} de {{date.ano}}</p>
        <br />
        <p class="centralizado">_______________________</p>
        <div class="dados">
          <p>Nome: {{dadosCliente.name}}</p>
          <p>{{dadosCliente.document}}: {{dadosCliente.document === 'CPF' ? formatCpf(dadosCliente.tax_id) : formatCnpj(dadosCliente.tax_id)}}</p>
        </div>
      </meu-painel>

      <div class="botao">
        <router-link :to="{ name: 'uploadDoc' }">
          <v-btn class="sombra" @click="gerarPdf()" color="primary">Gerar pdf para impressão</v-btn>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import Painel from "../../components/Painel.vue";
import api from "../../services/api";
import dadosCliente from "../../models/dadosCliente";

export default {
  components: {
    "meu-painel": Painel
  },

  data() {
    return {
      dadosCliente: new dadosCliente(),
      overlay: true,
      mostraDocumento: false,
      mensagemErro: "",
      date: {}
    };
  },

  created() {
    const data = new Date();

    const meses = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    this.date = {
      dia: data.getDate(),
      mes: meses[data.getMonth()],
      ano: data.getFullYear()
    };
  },

  mounted() {
    api
      .get(`/producers/${this.$route.params.client_id}`)
      .then(response => {
        this.dadosCliente = response.data;
        this.mostraDocumento = true;
        this.overlay = false;
        localStorage.setItem("produtor", JSON.stringify(this.dadosCliente));
      })
      .catch(err => {
        this.mensagemErro =
          "Não foi possivel conectar com o servidor! Entre em contato com a Nagro.";
        this.overlay = false;

        if (err.response.status === 400) {
          this.mensagemErro = "";
          this.mensagemErro = err.response.data.error;
          this.overlay = false;
        }
      });
  },

  methods: {
    gerarPdf() {
      var pdf = new jsPDF();
      pdf.setFontSize(11);
      var text = `\n\n\n\n\n\ AUTORIZAÇÃO PARA CONSULTA AO SISTEMA DE INFORMAÇÃO DE CRÉDITO (SCR)\n\n\n Eu, ${
        this.dadosCliente.name
      }, inscrito no ${this.dadosCliente.document} ${
        this.dadosCliente.document === "CPF"
          ? this.formatCpf(this.dadosCliente.tax_id)
          : this.formatCnpj(this.dadosCliente.tax_id)
      }, em virtude de operação de crédito, de qualquer natureza, pleiteada através do marketplace de crédito da Nagro, autorizo à Nagro Crédito Agro Ltda., inscrita no CNPJ sob o nº 22.165.622/0001-02, a consultar, a qualquer tempo, os débitos e responsabilidades decorrentes de operações com características de crédito que em meu nome e de minhas empresas, constem ou venham a constar do Sistema de Informações de Crédito(SCR), gerido pelo Banco Central do Brasil - Bacen, ou dos sistemas que venham a complementá-lo ou a substituí-lo. \n\n Autorizo também à Nagro Crédito Agro Ltda. a compartilhar os dados desta consulta com qualquer uma das fontes financeiras(instituições financeiras ou não), nas quais possa pleitear operação de crédito, de qualquer natureza, por intermediação da Nagro. \n\n\n  Declaro ainda, ser de meu conhecimento que: \n\n 1. As consultas ao SCR serão realizadas com base na presente autorização. \n\n 2. O SCR tem por finalidades prover informações ao Banco Central do Brasil, para fins de monitoramento  do  crédito  no  sistema  financeiro  e  para  o  exercício  de  suas  atividades  de fiscalização e propiciar o intercâmbio de informações entre instituições financeiras, conforme definido no § 1º do art. 1º da Lei Complementar nº 105, de 10 de janeiro de 2001, sobre o montante de responsabilidades de produceres em operações de crédito; \n\n 3. Poderei ter acesso aos dados constantes em meu nome no SCR por meio do sistema “registrato” do Banco Central do Brasil - Bacen; \n\n\n\n Uberlândia, ${
        this.date.dia
      } de ${this.date.mes} de ${
        this.date.ano
      } \n\n\n _______________________________________ \n\n Nome: ${
        this.dadosCliente.name
      } \n\n ${this.dadosCliente.document}: ${
        this.dadosCliente.document === "CPF"
          ? this.formatCpf(this.dadosCliente.tax_id)
          : this.formatCnpj(this.dadosCliente.tax_id)
      }`;
      text = pdf.splitTextToSize(text, 170);
      text.forEach((subtext, index) => {
        pdf.text(subtext, 20, 6 * (index + 1));
      });

      pdf.save("SCR - " + this.dadosCliente.name + ".pdf");
    },
    formatCpf(cpf) {
      cpf = cpf.replace(/\D/g, "");
      cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
      cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      return cpf;
    },
    formatCnpj(cnpj) {
      cnpj = cnpj.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        "$1.$2.$3/$4-$5"
      );
      return cnpj;
    }
  }
};
</script>

<style>
.home {
  padding-top: 20px;
}

.botao {
  position: fixed;
  bottom: 10px;
  margin: 0 auto;
  width: 100%;
}

.centralizado {
  text-align: center;
}

.erro {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.dados {
  width: 60%;
  margin: 30px auto 30px auto;
}
</style>